import { jwtDecode } from 'jwt-decode';
import type { OidcTokenClaims, AuthUser } from '@/types/auth';

/**
 * Retrieves the UAE Pass access token stored in localStorage.
 * Handles SSR safety by checking if window is defined.
 */
export function getAccessToken(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  return localStorage.getItem('accessToken');
}

/**
 * Safely parse OIDC JWT access token string into standardized AuthUser
 */
export function parseAccessToken(accessToken?: string | null): AuthUser | null {
  if (!accessToken) return null;
  try {
    const claims = jwtDecode<OidcTokenClaims>(accessToken);
    if (!claims) return null;

    return {
      sub: claims.sub || '',
      emiratesId: claims.EmiratesId || null,
      fullNameEn:
        claims.FullNameEn ||
        claims['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname'] ||
        claims.name ||
        null,
      fullNameAr: claims.FullNameAr || null,
      phoneNumber: claims.PhoneNumber || claims.phone_number || null,
      email: claims.email || claims['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'] || null,
      uaePassId: claims.UaePassId || null,
      unifiedId: claims.UnifiedId || null,
      isProfileCompleted: claims.IsProfileCompleted === 'True',
      rawClaims: claims,
    };
  } catch (error) {
    console.error('Failed to decode OIDC JWT access token:', error);
    return null;
  }
}
